import { useFormContext } from 'react-hook-form';
import type { ErrorResponse } from '@/types/apiTypes';
import { setBEFieldError } from '@/utils/setBEFieldError';
import { useGetPayloadData } from '../../components/ClientAutoSaveOnBlur/hooks/useGetPayloadData';
import { useUpdateClientPreferences } from '../useUpdateClientPreferences';

export const useUpdateTravelPreferencesByFieldName = () => {
  const { mutateAsync: updatePreferencesMutation } = useUpdateClientPreferences();

  const { setError } = useFormContext();
  const { getPassengerId, getPayloadData } = useGetPayloadData();

  const updateTravelPreferencesByFieldName = async (fieldName: string, fieldValue: unknown, onSuccess?: () => void) => {
    const passengerId = getPassengerId(fieldName);

    try {
      const payloadData = getPayloadData(fieldName, fieldValue);
      if (!payloadData) {
        onSuccess?.();
        return undefined;
      }

      return await updatePreferencesMutation({
        data: payloadData,
        clientId: passengerId,
      }, {
        onSuccess: () => {
          onSuccess?.();
        },
      });
    } catch (error) {
      setBEFieldError(error as ErrorResponse<unknown>, setError);
      return undefined;
    }
  };

  return { updateTravelPreferencesByFieldName };
};
